module.exports = __webpack_public_path__ + "static/img/qzlogo.900ccc64.png";